import type { CreateLocalActionRequest } from "~/pages/administration/workflows-page/workflows-dialog/views/action-view/hooks/use-action-view";
import type { PrintPdfConfiguration } from "~/types/api";

type ValidationErrors = {
  name?: string;
  presetName?: string;
  presetNameFieldId?: string;
  outputFieldId?: string;
  fileNameTemplate?: string;
  method?: string;
};

export const validateAction = (
  action?: CreateLocalActionRequest,
  useDynamicPreset?: boolean
): ValidationErrors => {
  if (!action) return {};

  const cfg = (action.configuration ?? {}) as PrintPdfConfiguration;

  let nameError: string | undefined;
  if (!action.name || action.name.trim() === "") {
    nameError = "Please enter valid value";
  }

  return {
    name: nameError,

    presetName:
      !useDynamicPreset && (!cfg.presetName || cfg.presetName.trim() === "")
        ? "Please select a PDF preset"
        : undefined,

    presetNameFieldId:
      useDynamicPreset && (!cfg.presetNameFieldId || cfg.presetNameFieldId === 0)
        ? useDynamicPreset
          ? "Please add a meta field with type String/String Choices and keyword 'preset'"
          : "Please select a PDF preset"
        : undefined,

    outputFieldId:
      !cfg.outputFieldId || cfg.outputFieldId === 0
        ? "Please add a meta field with Directory type"
        : undefined,

    fileNameTemplate:
      !cfg.fileNameTemplate || cfg.fileNameTemplate.trim() === ""
        ? "Please enter valid value"
        : undefined,

    method: !cfg.method || cfg.method.trim() === "" ? "Please enter valid value" : undefined,
  };
};
